var React = require('react');

function Users (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6 14c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4zm28 0c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4zm2 2c2.206 0 4 1.794 4 4v2c0 1.106-.894 2-2 2h-4.125c-.388-2.963-2.175-5.456-4.694-6.837A3.987 3.987 0 0 1 32 16.001h4zm-16 0c-3.869 0-7-3.131-7-7s3.131-7 7-7 7 3.131 7 7-3.131 7-7 7zm4.8 2c3.975 0 7.2 3.225 7.2 7.2V27c0 1.656-1.344 3-3 3H11c-1.656 0-3-1.344-3-3v-1.8c0-3.975 3.225-7.2 7.2-7.2h.519c1.306.625 2.744 1 4.281 1s2.981-.375 4.281-1h.519zm-13.981-.837A9.165 9.165 0 0 0 6.119 24H2c-1.106 0-2-.894-2-2v-2c0-2.206 1.794-4 4-4h4c1.1 0 2.094.444 2.819 1.162z"}));
}

Users.defaultProps = {"viewBox":"0 0 40 32"};

module.exports = Users;

Users.default = Users;
